import React, {useMemo, FC} from 'react';

import {DashboardComponent} from 'components/dashboard/dashboard-component/dashboard-component';
import {IFieldMeta, IWidgetsLayout} from 'entities/metadata';
import {selectContextRawData} from 'modules/context/context-selector';
import {useAppSelector} from 'store/config/hooks';

import {WidgetLayout} from '../../widget-layout';
import {createButtonProps} from './widget-layout-item.utils';

interface IWidgetLayoutItemProps {
    widget: IWidgetsLayout;
    field?: IFieldMeta;
    data?: any;
    entityName: string;
}

export const WidgetLayoutItem: FC<IWidgetLayoutItemProps> = ({
    widget, field, data, entityName,
}: IWidgetLayoutItemProps) => {
    const contextData = useAppSelector(selectContextRawData);
    const {buttonsBottom, buttonsTop} = useMemo(() => createButtonProps(widget?.buttons), [widget?.buttons]);

    return (
        <WidgetLayout
            title={widget.title}
            buttons={{
                bottom: buttonsBottom,
                top: buttonsTop,
            }}
        >
            {field && (
                <DashboardComponent
                    key={field?.key}
                    entityName={entityName}
                    meta={field}
                    data={data ? data[field.key] : undefined}
                    context={contextData}
                />
            )}

        </WidgetLayout>

    );
};
